import PropTypes from 'prop-types';

const CountryPropTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  lastUpdate: PropTypes.number.isRequired,
};

const BusinessPropTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  businessTaxId: PropTypes.string.isRequired,
  phone: PropTypes.string,
  email: PropTypes.string,
};

const IdentificationTypePropTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};

const CustomerPropTypes = {
  id: PropTypes.number.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  idDocumentNumber: PropTypes.string.isRequired,
  identificationTypeId: PropTypes.number.isRequired,
  identificationType: PropTypes.shape(IdentificationTypePropTypes).isRequired,
};

const BankPropTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  swiftCode: PropTypes.string.isRequired,
  countryId: PropTypes.number.isRequired,
  country: PropTypes.shape(CountryPropTypes).isRequired,
};

const BankAccountPropTypes = {
  id: PropTypes.number.isRequired,
  accountNumber: PropTypes.string.isRequired,
  interbankNumber: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  receipt: PropTypes.string.isRequired,
  bankId: PropTypes.number.isRequired,
  bank: PropTypes.shape(BankPropTypes).isRequired,
  businessId: PropTypes.number.isRequired,
  business: PropTypes.shape(BusinessPropTypes).isRequired,
  active: PropTypes.bool.isRequired,
  sunatTableCode: PropTypes.string.isRequired,
  orderNumber: PropTypes.number,
};

const ManualVoucherPaymentPropTypes = {
  id: PropTypes.number.isRequired,

  bankAccountId: PropTypes.number.isRequired,
  bankAccount: PropTypes.shape(BankAccountPropTypes).isRequired,

  manualVoucherId: PropTypes.number,

  operationNumber: PropTypes.string.isRequired,

  businessId: PropTypes.number,
  business: PropTypes.shape(BusinessPropTypes),

  customerId: PropTypes.number,
  customer: PropTypes.shape(CustomerPropTypes),

  amount: PropTypes.number.isRequired,
  depositDate: PropTypes.number.isRequired,
  approved: PropTypes.bool.isRequired,
  createDate: PropTypes.number.isRequired,
  lastUpdate: PropTypes.number.isRequired,
};

export default ManualVoucherPaymentPropTypes;
